import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import BaseModal from '@/components/modals/BaseModal.vue';

import { ModalHelper } from '@/helpers/modal-helper';
import { AccountModal } from '@/lazy-load-components';
import { AccountModes } from '@/enums/login';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { useModalStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListsForSignedInUsersModal',
  props: {
    header: null,
    body: null
  },
  setup(__props: any) {



const { setOpen } = useModalStore();

function openAccountModal(startScreen: AccountModes.SIGN_IN | AccountModes.SIGN_UP) {
	ModalHelper.close().then(() => setOpen(false));

	ModalHelper.openModal(AccountModal, { closable: true, startScreen }, { cssClass: 'account-modal' }).then(() =>
		setOpen(true)
	);

	TrackingHelper.trackEvent('user_account', {
		action: startScreen === AccountModes.SIGN_IN ? 'account_sign_in_clicked' : 'account_create_clicked',
		property: 'WatchlistSignupModal',
	});
}

return { __sfc: true,setOpen, openAccountModal, BasicButton, BaseModal, AccountModes }
}

})